import * as React from 'react';

import ReactTable from 'react-table';
import { CheckboxInline } from '@common/components/checkbox-inline/checkbox-inline';
import { CoverageOption } from '@models/CoverageOption';
import { OptionsViewModel } from '@models/common.models';
import { EditableFields, EditPermissions } from '@models/EditPermissions';

export interface CoverageOptionSelectComponentProperties {
  readonly coverageOptions: Array<CoverageOption>;
  readonly selectedCoverageOptions: Array<CoverageOption>;
  readonly toggleCoverageItem: (option: CoverageOption) => void;
  readonly isOrderEdit?: boolean;
  readonly isOpenContract?: boolean;
}

const REFRIGERATOR_KITCHEN_1 = 'Refrigerator Kitchen';
const REFRIGERATOR_KITCHEN_2 = 'Refrigerator (Kitchen)';
const REFRIGERATOR_KITCHEN_DUAL = 'Refrigerator Kitchen (Dual)';
const ADDITIONAL_REFRIGERATION = 'Additional Refrigeration';
const ADDITIONAL_REFRIGERATION_DUAL = 'Additional Refrigeration (Dual)';

export class CoverageOptionSelectComponent extends React.Component<CoverageOptionSelectComponentProperties> {
  constructor(props: CoverageOptionSelectComponentProperties) {
    super(props);
  }

  isSelected = (optionId: number): boolean => {
    if (!this.props.selectedCoverageOptions || this.props.selectedCoverageOptions.length === 0) {
      return false;
    }
    return this.props.selectedCoverageOptions.find(x => x.id === optionId) !== undefined;
  };

  toggleCoverageItem = (option: CoverageOption) => {
    // Logic for deselecting additional refrigeration if kitchen refrigeration is deselected

    // Yes this is hardcoded and gross but the client wanted it
    const isRefrigeratorKitchen = option.value === REFRIGERATOR_KITCHEN_1 || option.value === REFRIGERATOR_KITCHEN_2;
    let additionalRefrigerationOption;
    const additionalRefrigerationSelected =
      this.props.selectedCoverageOptions.filter(e => {
        const isAdditionalRefrigeration = e.value === ADDITIONAL_REFRIGERATION;
        if (isAdditionalRefrigeration) {
          additionalRefrigerationOption = e;
        }
        return isAdditionalRefrigeration;
      }).length > 0;

    const isRefrigeratorKitchenDual = option.value === REFRIGERATOR_KITCHEN_DUAL;
    let additionalRefrigerationDual;
    const additionalDualRefrigerationSelected =
      this.props.selectedCoverageOptions.filter(e => {
        const isAdditionalDualRefrigeration = e.value === ADDITIONAL_REFRIGERATION_DUAL;
        if (isAdditionalDualRefrigeration) {
          additionalRefrigerationDual = e;
        }
        return isAdditionalDualRefrigeration;
      }).length > 0;

    if (isRefrigeratorKitchen && additionalRefrigerationSelected && additionalRefrigerationOption) {
      this.props.toggleCoverageItem(additionalRefrigerationOption);
    }
    if (isRefrigeratorKitchenDual && additionalDualRefrigerationSelected && additionalRefrigerationDual) {
      this.props.toggleCoverageItem(additionalRefrigerationDual);
    }
    // Forward originally intended toggle
    this.props.toggleCoverageItem(option);
  };

  renderCoverageOptionRow(row: { index: number; original: CoverageOption }) {
    // Yes this is hardcoded and gross but the client wanted it
    // Checking for strings not id's because there are possibly 100s of id's for this
    const additionalRefrigerationDisabled =
      row.original.value === ADDITIONAL_REFRIGERATION &&
      this.props.selectedCoverageOptions.filter(
        e => e.value === REFRIGERATOR_KITCHEN_1 || e.value === REFRIGERATOR_KITCHEN_2
      ).length < 1 &&
      this.props.coverageOptions.filter(e => e.value === REFRIGERATOR_KITCHEN_1 || e.value === REFRIGERATOR_KITCHEN_2)
        .length > 0;

    const additionalDualRefrigerationDisabled =
      row.original.value === ADDITIONAL_REFRIGERATION_DUAL &&
      this.props.selectedCoverageOptions.filter(e => e.value === REFRIGERATOR_KITCHEN_DUAL).length < 1 &&
      this.props.coverageOptions.filter(e => e.value === REFRIGERATOR_KITCHEN_DUAL).length > 0;
    return (
      <CheckboxInline>
        <input
          onChange={e => e}
          onClick={() => {
            this.toggleCoverageItem(row.original);
          }}
          type="checkbox"
          checked={this.isSelected(row.original.id)}
          value={row.original.id}
          key={row.original.id}
          disabled={
            additionalRefrigerationDisabled ||
            additionalDualRefrigerationDisabled ||
            (this.props.isOrderEdit &&
              !EditPermissions.CanEditField(EditableFields.CoverageOptions, this.props.isOpenContract))
          }
        />
        <label>{row.original.value}</label>
      </CheckboxInline>
    );
  }

  render() {
    return (
      <ReactTable
        onPageChange={() => {
          Array.from(document.getElementsByClassName('rt-tbody')).forEach(element => {
            element.scrollTop = 0;
          });
        }}
        className="-striped -highlight"
        defaultPageSize={this.props.coverageOptions.length || 20}
        columns={[
          {
            accessor: 'id',
            Cell: row => this.renderCoverageOptionRow(row),
            Header: 'Coverage Options',
            sortable: false
          }
        ]}
        data={this.orderOptions(this.props.coverageOptions)}
        showPagination={false}
      />
    );
  }

  private orderOptions(options: Array<CoverageOption>) {
    // Yes this is hardcoded and gross but the client wanted it
    const refrigeratorKitchen = options.find(
      o => o.value === REFRIGERATOR_KITCHEN_1 || o.value === REFRIGERATOR_KITCHEN_2
    );
    const dualRefrigerator = options.find(o => o.value === REFRIGERATOR_KITCHEN_DUAL);
    const additionalRefrigeration = options.find(o => o.value === ADDITIONAL_REFRIGERATION);
    const additionalDualRefrigerator = options.find(o => o.value === ADDITIONAL_REFRIGERATION_DUAL);
    // this is a fix for sorting in IE11
    if (options.length) {
      let firstElement = options.shift();

      // Yes this is hardcoded and gross but the client wanted it, find those two and put at bottom
      var filtered = options.filter((option, index) => {
        return (
          option.value !== REFRIGERATOR_KITCHEN_1 &&
          option.value !== REFRIGERATOR_KITCHEN_2 &&
          option.value !== ADDITIONAL_REFRIGERATION &&
          option.value !== REFRIGERATOR_KITCHEN_DUAL &&
          option.value !== ADDITIONAL_REFRIGERATION_DUAL
        );
      });
      filtered = filtered.sort(this.compareOptions);
      if (firstElement) {
        filtered.unshift(firstElement);
      }
      if (refrigeratorKitchen) {
        filtered.push(refrigeratorKitchen);
      }
      if (additionalRefrigeration) {
        filtered.push(additionalRefrigeration);
      }
      if (dualRefrigerator) {
        filtered.push(dualRefrigerator);
      }
      if (additionalDualRefrigerator) {
        filtered.push(additionalDualRefrigerator);
      }
      return filtered;
    }
    return options;
  }

  private compareOptions(a: OptionsViewModel, b: OptionsViewModel) {
    if (a.value === 'Standard' || a.value < b.value) {
      return -1;
    } else if (a.value > b.value) {
      return 1;
    } else {
      return 0;
    }
  }
}



// WEBPACK FOOTER //
// ./src/contract/_components/coverage/_components/coverage-options-select.component.tsx